import "intersection-observer";
import "fastestsmallesttextencoderdecoder";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

if (!window.crypto) {
  // @ts-ignore
  window.crypto = window.msCrypto;
}